<template>
  <div id="notice__mobile">
    <section v-if="noticeData" class="notice__body">
      <div
        v-if="app_data['os'] === 'android'"
        v-html="noticeData.body_android"
      ></div>
      <div v-else v-html="noticeData.body_ios"></div>
    </section>
  </div>
</template>

<script>
import { fstore, auth } from '../config/firebaseConfig'

export default {
  name: 'NoticeApp',
  data() {
    return {
      app_data: null,
      noticeData: null,
    }
  },
  created() {
    this.app_data = {
      pagetype: this.$route.query.pagetype,
      pageid: this.$route.query.pageid,
      token: this.$route.query.key,
      os: this.$route.query.os,
    }
    if (this.app_data['token'])
      auth.signInWithCustomToken(this.app_data['token'])

    fstore
      .collection('applications')
      .doc('notices')
      .collection('noticelist')
      .doc(this.app_data['pageid'])
      .get()
      .then((notice) => {
        this.noticeData = notice.data()

        if (this.app_data['os'] === 'android') {
          try {
            /* eslint-disable-next-line */
            JYG.load_complete()
          } catch (err) {
            console.log(err)
          }
        }
      })
  },
}
</script>

<style lang="scss" scoped>
#notice__mobile {
  .notice__back {
    position: absolute;
    margin-left: 10px;
    margin-top: 10px;
    cursor: pointer;
  }

  .notice__header {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #ececec;

    h2 {
      float: left;
      margin-left: 4%;
      font-size: 15px;
      width: 70%;
      word-break: keep-all;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    h6 {
      float: right;
      margin-right: 4%;
      font-size: 13px;
      color: #9b9b9b;
    }
  }

  .notice__body {
    width: 92%;
    margin-left: 4%;
    margin-right: 4%;

    div {
      font-size: 13px;
      margin-top: 12px;
      line-height: 20px;
      color: #9b9b9b;
      white-space: pre-line;
    }
  }
}
</style>
